import { Doc as YDoc, Map as YMap } from 'yjs';
import { ErrorCode } from './error-code';

// Dict is created in yjs-database in the hocuspocus app
export type ErrorYjsDict = Partial<Record<`${ErrorCode}`, number>>;

export function getErrorsMap(yDoc: YDoc): YMap<unknown> {
  return yDoc.getMap('errors');
}
